import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@mui/material";
import plusIcon from "@iconify/icons-mdi/plus";
import { InlineIcon } from "@iconify/react";
import useOcButtonGroup from "oc/hooks/use-button-group";

interface MyTimesheetEntitySelectorProps {
  entity: string;
  onNewEntity: () => void;
  isMobile: boolean;
}

export const MyTimesheetEntitySelector: React.FC<
  MyTimesheetEntitySelectorProps
> = ({ entity, onNewEntity, isMobile }) => {
  const { t } = useTranslation();

  const buttonsDef = ["OC_ACTIVE", "OC_ALL"];
  const { OcButtonGroup } = useOcButtonGroup({
    id: `MySheet${entity}EntitySelector`,
    buttonsDef,
  });

  const handleNewEntity = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onNewEntity();
  };

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column-reverse" : "row"}
      justifyContent="space-between"
      alignItems="center"
    >
      <Box width="200px" />
      <OcButtonGroup />
      {isMobile && <Box height="36px" />}
      <Box
        width={isMobile ? "100%" : "200px"}
        display="flex"
        flexDirection="row"
        justifyContent="flex-end"
      >
        <Button
          id={`${entity}`}
          variant="contained"
          color="primary"
          disableElevation
          startIcon={<InlineIcon icon={plusIcon} />}
          onClick={handleNewEntity}
        >
          {t("OC_NEW")} {t(entity)}
        </Button>
      </Box>
    </Box>
  );
};

export default MyTimesheetEntitySelector;
